import type { GameResponse } from '@warcarp/api-types'
import { isMyTurn } from './turnHelpers'

/** Pending invitations remain actionable until joined/declined, even if read. */
export function gameMenuAttentionGames(games: readonly GameResponse[], userId: string | undefined, currentGameId: string): GameResponse[] {
  if (!userId) return []
  return games.filter(game => game.id !== currentGameId && (
    isMyTurn(game, userId) || (game.status === 'LOBBY' && game.viewerInvitationStatus === 'pending'
      && !game.players.some(player => player.userId === userId))
  ))
}
